import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { User } from '@app/core/domain';

export interface UserStateModel {
  user: User;
  loading: boolean;
  hasDateOfBirth: boolean;
  ageVerifiedNegative: boolean;
  hasMultiplePlcAccounts: boolean;
  hasMultiplePlcCardGroups: boolean;
  hasMarkedMarketingConsent: boolean;
}

function createInitialState(): UserStateModel {
  return {
    user: null,
    loading: false,
    hasDateOfBirth: null,
    ageVerifiedNegative: null,
    hasMultiplePlcAccounts: false,
    hasMultiplePlcCardGroups: false,
    hasMarkedMarketingConsent: true,
  };
}

@Injectable()
@StoreConfig({ name: 'user' })
export class UserStore extends Store<UserStateModel> {

  constructor() {
    super(createInitialState());
  }
}
